import IconCloseModal from "app/components/Icon/components/IconCloseModal/IconCloseModal";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";

type ModalHeaderProps = {
  hideLossLimitsModal: () => void;
  setUpdateLossLimitsPrompt: () => void;
};

const ModalHeader = ({
  hideLossLimitsModal,
  setUpdateLossLimitsPrompt,
}: ModalHeaderProps): JSX.Element => {
  return (
    <div className="loss-limits-form-modal__header">
      <div className={"loss-limits-form-modal__header--logo"}>&nbsp;</div>
      <div className={"loss-limits-form-modal__header--loss-limit"}>&nbsp;</div>
      <div
        className={"loss-limits-form-modal__header--close"}
        onClick={() => {
          setUpdateLossLimitsPrompt();
          hideLossLimitsModal();
        }}
      >
        <IconCloseModal />
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  hideLossLimitsModal: (username: string) =>
    dispatch.lossLimitsModel.hideLossLimitsModal(),
  setUpdateLossLimitsPrompt: () => {
    dispatch.lossLimitsModel.setUpdateLossLimitsPrompt();
  },
});

export default connect(null, mapDispatchToProps)(injectIntl(ModalHeader));
